import React from 'react';
import { ChevronDown } from 'lucide-react';
import { cn } from '../../../lib/utils';
import type { FilterOption } from '../types';

interface SelectInputProps {
  value: string;
  onChange: (value: string) => void;
  options: FilterOption[];
  label?: string;
  disabled?: boolean;
  className?: string;
}

export const SelectInput: React.FC<SelectInputProps> = ({
  value,
  onChange,
  options,
  label,
  disabled = false,
  className,
}) => {
  const selectedOption = options.find((opt) => opt.value === value);

  return (
    <div className={cn('flex flex-col gap-1.5', className)}>
      {label && (
        <label className="text-sm font-medium text-text-secondary">{label}</label>
      )}
      <div className="relative">
        <select
          value={value}
          onChange={(e) => onChange(e.target.value)}
          disabled={disabled}
          className={cn(
            'w-full h-10 px-3 pr-10 rounded-lg appearance-none',
            'bg-surface-container border border-border-subtle',
            'text-text-primary text-sm',
            'focus:outline-none focus:ring-2 focus:ring-accent-primary focus:border-transparent',
            'disabled:opacity-50 disabled:cursor-not-allowed',
            'cursor-pointer'
          )}
        >
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-text-muted pointer-events-none" />
      </div>
      {selectedOption?.subtitle && (
        <p className="text-xs text-text-muted mt-0.5">{selectedOption.subtitle}</p>
      )}
    </div>
  );
};

export default SelectInput;
